const AppBar = {
  colorDefault: {
    backgroundColor: '#fff',
    // color: ninja.getShade(7),
  },
}

export default AppBar
